<template>
    <div id="online-residence-application">
        <v-overlay absolute="" opacity="0.2" :value="loader">
            <v-progress-circular :color="kingsGreen" indeterminate size="32"></v-progress-circular>
        </v-overlay>
        <v-snackbar v-model="snackbar.status" top :color="snackbar.color" :timeout="snackbar.timeout">
            <v-icon class="mr-1">{{ snackbar.icon }}</v-icon> {{ snackbar.message }}
        </v-snackbar>
        <online-residence-application-toolbar :user="user"></online-residence-application-toolbar>
        <v-container class="fill-height justify-center" fluid>
            <online-residence-application-form :user="user" @setLoader="setLoader" @setNotification="setNotification">
            </online-residence-application-form>
        </v-container>
    </div>
</template>

<script>
import OnlineResidenceApplicationForm from '../../components/Student/OnlineResidenceApplication/Form';
import OnlineResidenceApplicationToolbar from '../../components/Student/OnlineResidenceApplication/Toolbar';

export default {
    name: 'online-residence-application',
    components: {
        OnlineResidenceApplicationForm,
        OnlineResidenceApplicationToolbar
    },
    props: {
        user: {
            required: true
        }
    },
    data() {
        return {
            loader: true,
            snackbar: {
                color: 'success',
                icon: '',
                message: '',
                status: false,
                timeout: 5000
            }
        }
    },
    methods: {
        setLoader(bool) {
            this.loader = bool;
        },
        setNotification(color, icon, message, status) {
            // Reset snackbar
            this.snackbar.status = false;

            // Set snackbar fields
            this.snackbar.color = color;
            this.snackbar.icon = icon;
            this.snackbar.message = message;
            this.snackbar.status = status;
        }
    },
    computed: {
        kingsGreen() {
            return '#004236';
        }
    }
}
</script>